import { apiFetch, type AjaxResult } from './http';
import type { HomeSearchHelpItem } from '@/constants/home-search-help';

export async function fetchHomeSearchHelpItems(): Promise<AjaxResult<HomeSearchHelpItem[]>> {
  return apiFetch<HomeSearchHelpItem[]>('/api/app/home/search-help', { method: 'GET' });
}
